import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const mql = window.matchMedia(query);
    setMatches(mql.matches);

    const listener = (): void => setMatches(mql.matches);
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [query]);

  return matches;
}

export const MIN_WIDTH_DESKTOP = '(min-width: 560px)';
export const WIDE_DESKTOP = '(min-width: 1024px)';
